import React from 'react';
import { motion } from 'framer-motion';
import { SparklesIcon } from './Icons';
import { FEATURES } from '../data/content';

const FeatureCard = ({ feature, index }) => {
  const { Icon, title, description } = feature;
  
  return (
    <motion.div 
      className="glass-panel p-7 sm:p-8 rounded-3xl flex items-start space-x-5 hover:border-brand-500/50 hover:shadow-xl dark:hover:shadow-brand-500/10 transition-all duration-300 relative overflow-hidden group text-left specular-border"
      initial={{ opacity: 0, y: 25 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.4, delay: index * 0.1 }}
    >
      <div className="absolute inset-0 bg-gradient-to-tr from-brand-500/5 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none" />
      
      <div className="w-12 h-12 rounded-2xl bg-slate-100 dark:bg-slate-800/80 border border-slate-200/80 dark:border-slate-700/80 text-brand-600 dark:text-brand-400 flex items-center justify-center shrink-0 group-hover:scale-105 transition-transform duration-200 shadow-sm">
        <Icon className="w-6 h-6" />
      </div>
      
      <div className="space-y-1.5 min-w-0">
        <h3 className="text-xl font-bold text-slate-900 dark:text-white font-outfit tracking-tight group-hover:text-brand-600 dark:group-hover:text-brand-400 transition-colors">
          {title}
        </h3>
        <p className="text-slate-600 dark:text-slate-400 text-sm leading-relaxed font-light">
          {description}
        </p>
      </div>
    </motion.div>
  );
};

const FeaturesSection = ({ features = FEATURES, projectName = "Supreme Adventure" }) => {
  return (
    <section id="features" className="py-20 md:py-28 relative">
      <div className="max-w-7xl mx-auto px-6 sm:px-8">
        <div className="max-w-3xl mx-auto text-center mb-16 space-y-4">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full text-xs font-semibold bg-brand-500/10 text-brand-600 dark:text-brand-400 border border-brand-500/20 font-inter">
            <SparklesIcon className="w-3.5 h-3.5" />
            <span>Enterprise Hardened</span>
          </div>
          <h2 className="text-3xl sm:text-5xl font-extrabold font-outfit text-slate-900 dark:text-white tracking-tight">
            Built for Mission-Critical Production
          </h2>
          <p className="text-slate-600 dark:text-slate-400 text-base sm:text-lg font-light leading-relaxed">
            Eliminate sandbox lag, ensure strict multi-tenant tenant isolation, and run on any LLM provider without vendor lock-in.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-5xl mx-auto">
          {features.map((feature, index) => (
            <FeatureCard key={index} feature={feature} index={index} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeaturesSection;
